// Pre-fill checkboxes from URL param
const params = new URLSearchParams(window.location.search);
const interest = params.get('interest');

if (interest) {
    document.querySelectorAll('.gfield-choice-input[type="checkbox"]').forEach(checkbox => {
        if (checkbox.value === interest) {
            checkbox.checked = true;
        }
    });
}

// Confirmation dialog
const confirmationDialog = document.getElementById('gform-confirmation-dialog');

if (confirmationDialog) {
    function openConfirmationDialog() {
        document.body.style.overflow = 'hidden';
        confirmationDialog.classList.add('is-opening');
        confirmationDialog.showModal();
        requestAnimationFrame(() => {
            confirmationDialog.classList.remove('is-opening');
        });
        confirmationDialog.querySelector('[data-gform-dialog-close]')?.focus();
    }

    function closeConfirmationDialog() {
        confirmationDialog.classList.add('is-closing');
        setTimeout(() => {
            confirmationDialog.classList.remove('is-closing');
            confirmationDialog.close();
            document.body.style.overflow = '';
        }, 200);
    }

    // Intercept GF confirmation (exclude form ID 1)
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId === 1) {
            return;
        }
        jQuery('#gform_confirmation_wrapper_' + formId).hide();
        openConfirmationDialog();
    });

    // Close buttons
    confirmationDialog.addEventListener('click', e => {
        if (e.target.closest('[data-gform-dialog-close]')) {
            closeConfirmationDialog();
        }
    });

    // Backdrop click
    confirmationDialog.addEventListener('click', e => {
        if (e.target === confirmationDialog) {
            closeConfirmationDialog();
        }
    });

    // ESC key
    confirmationDialog.addEventListener('cancel', e => {
        e.preventDefault();
        closeConfirmationDialog();
    });
}
